import {
    AddressingCountryCode,
    AddressField,
    AdministrativeAreaType,
    DependentLocalityType,
    FieldOverride,
    LocalityType,
    PostalCodeType,
    type AddressingLocaleKey,
} from '../generated/types';

import { countryNamesLoaders } from '../generated/loaders';

export function isAddressingCountryCode(
    value: unknown
): value is AddressingCountryCode {
    return (
        typeof value === 'string' &&
        Object.values(AddressingCountryCode).includes(value as any)
    );
}

export function isAddressField(value: unknown): value is AddressField {
    return (
        typeof value === 'string' &&
        Object.values(AddressField).includes(value as any)
    );
}

export function isAdministrativeAreaType(
    value: unknown
): value is AdministrativeAreaType {
    return (
        typeof value === 'string' &&
        Object.values(AdministrativeAreaType).includes(value as any)
    );
}

export function isDependentLocalityType(
    value: unknown
): value is DependentLocalityType {
    return (
        typeof value === 'string' &&
        Object.values(DependentLocalityType).includes(value as any)
    );
}

export function isFieldOverride(value: unknown): value is FieldOverride {
    return (
        typeof value === 'string' &&
        Object.values(FieldOverride).includes(value as any)
    );
}

export function isLocalityType(value: unknown): value is LocalityType {
    return (
        typeof value === 'string' &&
        Object.values(LocalityType).includes(value as any)
    );
}

export function isPostalCodeType(value: unknown): value is PostalCodeType {
    return (
        typeof value === 'string' &&
        Object.values(PostalCodeType).includes(value as any)
    );
}

export function isAddressingLocaleKey(
    value: unknown
): value is AddressingLocaleKey {
    return (
        typeof value === 'string' &&
        Object.keys(countryNamesLoaders).includes(value as any)
    );
}
